import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ children }) => {
  return localStorage.getItem("token") ? children : <Navigate to="/" />;
};
export default PrivateRoutes;
